<template>
<div class="row no-gutters justify-content-center align-items-center how-to-earn-points-overlay" v-on:click.stop="closeHowToEarnPointsModal()">
  <div class="col-10 col-md-6 how-to-earn-points-modal">
    <img :src="getImage('close-icon-white.svg')" class="close-button" v-on:click.stop="closeHowToEarnPointsModal()">
    <h5>Please take a look at the breakdown below of how to earn points:</h5>
    <table class="table">
      <thead>
      <tr>
        <th>Description</th>
        <th>Points</th>
      </tr>
      </thead>
      <tbody>
      <tr class="" v-for="(pointScoringRule, index) in pointsScoringBreakdown" :key="index">
        <td>{{pointScoringRule.Name}}</td>
        <td>{{pointScoringRule.Value}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "HowToEarnPointsModal",
  computed: mapState(['brand', 'pointsScoringBreakdown']),
  methods: {
    ...mapMutations(['toggleShowHowToEarnPointsModal']),
    getImage(imagePath) {
      return require(`../assets/${imagePath}`);
    },
    closeHowToEarnPointsModal() {
      this.toggleShowHowToEarnPointsModal();
    }
  }
}
</script>

<style scoped lang="scss">
th {
 border-top: 2px solid #000000 !important;
 border-bottom: 2px solid #000000 !important;
  font-weight: bold;
  color: #000000;
  font-size: 1.2rem;
}

tbody tr {
  border-top: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
  font-weight: normal;
  color: #FFFFFF;
}

td {
  font-size: 0.9rem;
}

.how-to-earn-points-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: rgba(79, 79, 79, 0.7);
  width: 100vw;
  height: 100vh;
}

.how-to-earn-points-modal {
  position: relative;
  opacity: 1;
  background-color: $how-to-earn-points-modal-background;
  box-shadow: 0 0.5rem 1rem 0 rgba(0,0,0,.7),
  0 -0.25rem 1.5rem $how-to-earn-points-modal-background inset,
  0 0.75rem 0.5rem rgba(255, 255, 255, 0.4) inset,
  0 0.25rem 0.5rem 0 #ffffff inset;
  padding: 2.6rem 1rem 2.5rem 1rem !important;
  z-index: 6;
  pointer-events: none;
  border-radius: 4px;
}

.close-button {
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0.8rem 0.8rem 0 0;
}

.close-button:hover {
  cursor: pointer;
}
</style>
